import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';

export default function CallButton({ label, className = '' }) {
  return (
    <div className={`call-row ${className}`.trim()}>
      <a href={SUPPORT_PHONE_TEL} className="call-btn">
        {label || `Call Now : ${SUPPORT_PHONE_LABEL}`}
      </a>
    </div>
  );
}
